export function displayStringForDiscountPercentageRange(range) {
  if (!range.max) {
    return '';
  }

  if (range.min === range.max) {
    return "".concat(range.min, "% OFF");
  }

  if (range.min === 0) {
    return "UP TO ".concat(range.max, "% OFF");
  }

  return "".concat(range.min, "% \u2013 ").concat(range.max, "% OFF");
}